import { render, staticRenderFns } from "./TotalPaid.vue?vue&type=template&id=10521814&"
import script from "./TotalPaid.vue?vue&type=script&lang=js&"
export * from "./TotalPaid.vue?vue&type=script&lang=js&"
import style0 from "./TotalPaid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports